import { render, staticRenderFns } from "./tuoguan.vue?vue&type=template&id=33f34b1c&scoped=true&"
import script from "./tuoguan.vue?vue&type=script&lang=js&"
export * from "./tuoguan.vue?vue&type=script&lang=js&"
import style0 from "./tuoguan.vue?vue&type=style&index=0&id=33f34b1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f34b1c",
  null
  
)

export default component.exports